import React, { useEffect, useRef } from 'react';
import {
  Box, Divider, IconButton, SvgIcon, Tooltip
} from '@material-ui/core';

import { makeStyles } from '@material-ui/core/styles';
import { AddPhotoAlternate } from '@material-ui/icons';

import QuillEditor from 'src/components/QuillEditor';
import Button from 'src/components/Button';
import { Trash2 } from 'react-feather';
import debounce from 'just-debounce-it';
import { WORKFLOW } from '../../../../constants/perspectiveConstants';
import { InspectorProps } from '../../../../constants/widgetConstants';
import useDebounce from '../../../../../hooks/useDebounce';
import SlateRichTextArea from '../../../../../components/slate/SlateRichTextArea';

const useStyles = makeStyles((theme) => ({
  editor: {
    flexGrow: 1,
    '& .ql-editor': {
      minHeight: 300
    }
  },
  action: {
    marginRight: theme.spacing(1)
  }
}));

const TextWidgetInspector = ({
  workflowId,
  selectedWidget,
  saveWidget,
  deleteWidget,
  perspectiveType,
}: InspectorProps) => {
  const [widgetData, setWidgetData] = React.useState(selectedWidget.data || {});
  const [widgetId, setWidgetId] = React.useState(selectedWidget.id);

  React.useEffect(() => {
    if (selectedWidget.id !== widgetId) {
      setWidgetId(selectedWidget.id);
      setWidgetData(selectedWidget.data || {});
    }
  }, [selectedWidget]);

  const classes = useStyles();

  const debouncedData = useDebounce(widgetData, 300);
  useEffect(() => {
    if (debouncedData) saveWidget(selectedWidget.id, { data: debouncedData });
  }, [debouncedData]);

  return (
    <Box>
      <SlateRichTextArea
        disableVariables={perspectiveType === WORKFLOW}
        // className={classes.editor}
        value={widgetData.text}
        workflowId={workflowId}
        showToolbar
        onChange={(value: any) => {
          setWidgetData({
            ...widgetData,
            text: value,
          });
        }}
      />
      <Divider />
      <Box
        display="flex"
        justifyContent="space-between"
        py={1}
      >
        {/* @ts-expect-error ts-migrate(2322) FIXME: Type '{ children: Element; look: string; className... Remove this comment to see the full error message */}
        <Button
          className={classes.action}
          onClick={() => deleteWidget(selectedWidget.id)}
        >
          <SvgIcon fontSize="small">
            <Trash2 />
          </SvgIcon>
        </Button>
      </Box>
    </Box>
  );
};

export default TextWidgetInspector;
